const DOCUMENT = 'USER_GUIDE_';

const actions = {
  LOAD_CONTENTS_REQUEST: DOCUMENT + 'LOAD_CONTENTS_REQUEST',
  LOAD_CONTENTS_SUCCESS: DOCUMENT + 'LOAD_CONTENTS_SUCCESS',

  loadContentsRequest: data => {
    return {
      type: actions.LOAD_CONTENTS_REQUEST,
      payload: { ...data },
    };
  },

  loadContentsSuccess: data => ({
    type: actions.LOAD_CONTENTS_SUCCESS,
    payload: data,
  }),
};

export default actions;
